module.exports = __webpack_public_path__ + "static/media/mailroom_logo.98842544.svg";